import React, { useState, useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import { Row, Col, Button, Form, Input, Select, Upload, Spin, message, Switch } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { DataRequestAction, DataGetAction } from '../../../redux/actions/http'
import { PlusOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import useDynamicRefs from 'use-dynamic-refs';
import SubQuestion from '../components/SubQuestionModal'
const { Option } = Select;
const Index = () => {

    const ModalType = "SubQuestion-Modal"
    const dispatch = useDispatch();
    const [getRef, setRef] = useDynamicRefs();
    const dailyActivityProps = useSelector(state => state.dailyLivingActivityR);

    const { dailyActivityLoader,
        settingId,
        dailyActivitySuccess,
        dailyActivityError, dailyLivingActivities, fetchingLoader, selectedQuestion } = dailyActivityProps;

    const QuestionObjectArray = dailyLivingActivities;
    let initialState = {
        loading: false,
        imageUrl: '',
    }




    const [photoList, setPhotoState] = useState(initialState)
    const [typeOfQuestion, setTypeOfQuestion] = useState({})
    const [supQuestions, setSubQuestionQuestion] = useState({})
    const [questionCount, setQuestionCount] = useState(0)
    const [selectedQuestionIndex, setselectedQuestion] = useState(0)

    const [showFurtherDetail, setShowFurtherDetailButton] = useState({})
    const [questionOptionType, setQuestionOptionType] = useState({})
    const [form] = Form.useForm();

    const SelectQuestionType = ['Radio', 'CheckBox', 'TextArea']
    const SelectQuestionOptionType = ['With Image', 'Without Image']

    if (dailyActivitySuccess) {
        message.success("Record updated successfully");
        dispatch({
            type: "dailyLivingActivity_reset_state"
        })
    }

    if (dailyActivityError) {
        message.error("Some error occur while updating record");
        dispatch({
            type: "dailyLivingActivity_reset_state"
        })
    }

    const fetchSetting = () => {
        dispatch(DataGetAction('getQuestionnaireSetting', '', 'fetchingSetting'));
    }

    useEffect(fetchSetting, [])

    const setDailyCount = () => {
        if (QuestionObjectArray && QuestionObjectArray.questions) {
            setQuestionCount(QuestionObjectArray.questions.length)
        }
    }

    useEffect(setDailyCount, [QuestionObjectArray])


    // const scrollToOption = (offset) => {
    //     console.log("======== Offset =====",offset)
    //     const y = offset + 80;
    //     scrollViewRef.current.scrollTo({x: 0, y, animated: true});

    // }



    const executeScroll = (index) => {
        const id1 = getRef(`questionId_${index}`);
        setselectedQuestion(index);
        id1.current.scrollIntoView({ behavior: "smooth" });;
    }


    const onFinish = (data) => {
        data.questions.forEach((Item, index) => {
            if (Item.questionOptionType === "With Image") {
                Item.questionOptionImage.forEach((item, childIndex) => {
                    if (item.image_optionLabel && item.image_optionLabel.file) {
                        item.image_optionLabel = item.image_optionLabel.file.response.url
                    }
                    if (item.furtherDetail) {
                        let key = index + ".questionOptionImage." + childIndex
                        if (supQuestions[key]) {
                            item.subQuestion = supQuestions[key]
                        }
                    }
                })
            }
        })

        let dataObj = { "arrayKey": "dailyLivingActivities", value: data };

        if (settingId) {
            dataObj._id = settingId
        }


        dispatch(DataRequestAction('POST', 'updateQuestionnaire', dataObj, '', 'savingDailyLivingActivity', false));
    }


    const handleChange = (key, data) => {
        form.setFieldsValue({ [key]: data });
    }

    const renderGermanEditor = (type) => {
        return <ReactQuill onChange={(data) => handleChange(type, data)} />
    }

    const questionTypeSelected = (value, key) => {
        let newKey = key.join("-")
        let obj = typeOfQuestion;
        obj[newKey] = value;
        setTypeOfQuestion({ ...obj })
    }

    const questionOptionTypeSelected = (value, key) => {
        let newKey = key.join("-")
        let obj = questionOptionType;
        obj[newKey] = value;
        setQuestionOptionType({ ...obj })
    }


    const renderFormListWithOutImage = (key, checkValue) => {
        let keyCondition = checkValue.join("-");

        if ((QuestionObjectArray.questions) && ((QuestionObjectArray.questions[`${key[0]}`] && QuestionObjectArray.questions[`${key[0]}`]['questionOptionType'] === "Without Image") || (questionOptionType && questionOptionType[`${keyCondition}`] === 'Without Image'))) {
            return <Form.List name={key}>
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field, index) => (
                            <Row>
                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row className="">
                                        <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                                            <span style={{
                                                display: 'flFex',
                                                flex: 1,
                                                height: '60%',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}>{index + 1}</span>
                                        </Col>
                                        <Col xl={14} lg={14} md={14} sm={22} xs={22}>
                                            <Form.Item
                                                name={[field.name, 'optionLabel']}
                                                fieldKey={[field.fieldKey, 'optionLabel']}
                                                rules={[{ required: true, message: 'Missing Option Label' }]}
                                            >
                                                <Input placeholder="optionLabel" style={{ width: 250 }} />
                                            </Form.Item>
                                        </Col>
                                        <Col xl={4} lg={4} md={4} sm={2} xs={2}>
                                            <Button type="dashed" className="gx-pt-0" onClick={() => remove(field.name)}>
                                                <span style={{ color: 'red' }}>Delete</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row className="gx-mr-3">
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                            <Form.Item
                                                className="quilEditor"
                                                name={[field.name, 'decisionTree']}
                                                fieldKey={[field.fieldKey, 'decisionTree']}
                                                rules={[{ required: true, message: 'Missing decision Tree' }]}
                                                initialValue=''
                                            >
                                                {renderGermanEditor([field.name, 'decisionTree'])}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        ))
                        }
                        <Form.Item>
                            <Button type="dashed" className="gx-pt-0" style={{ maxWidth: '700px' }} onClick={() => add()} block icon={<PlusOutlined />}>
                                Add options
                </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        }
    }


    const setFormImageUrl = (data, key, parentKey) => {

        let newKey = parentKey.join(".") + "." + key.join(".")
        let dataObj = photoList;

        if (data.file.status === "removed") {
            dataObj[newKey] = "";
            setPhotoState({ ...dataObj });
        } else {
            console.log("========= dataObj", dataObj)
            dataObj[newKey] = data;
            setPhotoState({ ...dataObj });
        }
    }

    const uploadButtonNoImageExit = (key, parentKey) => {
        let newKey = parentKey.join(".") + "." + key.join(".")
        console.log("======= newKey ======", newKey)
        if (photoList && !photoList[newKey]) {
            return <div> <span className="icon icon-image gx-d-block" style={{ fontSize: '33px', opacity: '0.3' }}></span>
                <span>upload picture</span></div>
        }
    }

    const showSubQuestionModal = (parentId, optionNoKey) => {
        const key = parentId.join('.') + '.' + optionNoKey;

        if (supQuestions[key]) {
            dispatch({
                type: ModalType,
                payload: supQuestions[key],
                selectedQuestion: key
            })
        } else {


            if (QuestionObjectArray.questions[parentId[0]] && QuestionObjectArray.questions[parentId[0]].questionOptionImage && QuestionObjectArray.questions[parentId[0]]['questionOptionImage'][optionNoKey].furtherDetail) {
                const subQuestion = QuestionObjectArray.questions[parentId[0]]['questionOptionImage'][optionNoKey].subQuestion
                dispatch({
                    type: ModalType,
                    payload: subQuestion,
                    selectedQuestion: key
                })
            } else {

                dispatch({
                    type: ModalType,
                    payload: null,
                    selectedQuestion: key
                })
            }

        }



    }

    const renderShowDetailQuestionButton = (baseField, parentField, optionNoKey) => {
        let newKey = parentField.join(".") + "." + optionNoKey
        console.log("================= showFurtherDetail", showFurtherDetail);
        if (!showFurtherDetail.hasOwnProperty(newKey)) {
            if ((showFurtherDetail && showFurtherDetail[newKey]) || (QuestionObjectArray.questions && QuestionObjectArray.questions[parentField[0]] && QuestionObjectArray.questions[parentField[0]][parentField[1]] && QuestionObjectArray.questions[parentField[0]][parentField[1]][optionNoKey] && QuestionObjectArray.questions[parentField[0]][parentField[1]][optionNoKey]['furtherDetail'])) {
                return <Button type="dashed" className="gx-pt-0 gx-mr-3 subCriptionStyle" onClick={() => showSubQuestionModal(parentField, optionNoKey)}>
                    <span style={{ color: 'red' }}>Sub Question</span>
                </Button>
            }
        } else if (showFurtherDetail && showFurtherDetail[newKey]) {
            return <Button type="dashed" className="gx-pt-0 gx-mr-3" onClick={() => showSubQuestionModal(parentField, optionNoKey)}>
                <span style={{ color: 'red' }}>Sub Question</span>
            </Button>
        }
    }



    const showSwitchValue = (value, optionNo, parentNo) => {
        let obj = showFurtherDetail;
        let newKey = parentNo.join(".") + "." + optionNo
        obj[newKey] = value;

        setShowFurtherDetailButton({ ...obj })
    }



    const renderUploadButtonWithCondition = (imageUrl, field, key) => {
        return imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButtonNoImageExit([field.name, 'image_optionLabel'], key)



    }

    const renderUploadButton = (keyForImage, key, field) => {

        console.log("=========== Main keys ", keyForImage, key, field)

        let newKey = key.join(".") + "." + ([field.name, 'image_optionLabel'].join("."))
        console.log("======= new key", newKey)
        let imageUrl = QuestionObjectArray.questions[`${key[0]}`] && QuestionObjectArray.questions[`${key[0]}`]['questionOptionImage'][field.name] && QuestionObjectArray.questions[`${key[0]}`]['questionOptionImage'][field.name]['image_optionLabel'];
        console.log("============== photoList",
            photoList,
            `${newKey}`,
            photoList[newKey] && photoList[newKey].file);

        if (photoList && photoList[newKey] && photoList[newKey].file.status === "done") {
            imageUrl = photoList[newKey].file.response.url
        }


        return (
            <Form.Item
                name={[field.name, 'image_optionLabel']}
                fieldKey={[field.fieldKey, 'image_optionLabel']}
                rules={[{ required: true, message: 'Upload image for Option ' }]}
            >
                <Upload
                    action={`${process.env.REACT_APP_ROOT_URL}/uploadProfileImage`}
                    method="POST"
                    multiple={false}
                    showUploadList={false}
                    onChange={(data) => setFormImageUrl(data, [field.name, 'image_optionLabel'], key)}
                    headers={{
                        'Authorization': localStorage.getItem('token'),
                    }}
                    maxCount={1}
                    listType="picture-card"
                    accept='image/jpeg,image/jpg,image/png'
                >

                    {renderUploadButtonWithCondition(imageUrl, field, key)}



                </Upload>
            </Form.Item>)
    }


    const renderFormListWithImageOption = (key, checkValue) => {
        let keyCondition = checkValue.join("-");

        if ((QuestionObjectArray.questions) && ((QuestionObjectArray.questions[`${key[0]}`] && QuestionObjectArray.questions[`${key[0]}`]['questionOptionType'] === "With Image") || (questionOptionType && questionOptionType[`${keyCondition}`] === 'With Image')))
            return <Form.List name={key}>
                {(fields, { add, remove }) => {

                    return (
                        <>
                            {fields.map((field, index) => {
                                let keyForImage = [field.name, 'image_optionLabel'].join(".")
                                let newKey = key.join(".") + "." + field.name;
                                return (
                                    <Row className="gx-p-0">
                                        <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-p-0">
                                            <Row className="gx-p-0 gx-m-0">
                                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-p-0">
                                                    <h1 className="questionContainerOptionHeader">
                                                        <span>Option: {index + 1}</span>
                                                        <span>
                                                            {renderShowDetailQuestionButton([field.name, 'furtherDetail'], key, field.name)}
                                                            <Button type="dashed" className="gx-pt-0" onClick={() => {
                                                                remove(field.name);
                                                                showSwitchValue(false, field.name, key)
                                                            }}>
                                                                <span style={{ color: 'red' }}>Delete</span>
                                                            </Button>

                                                        </span>
                                                    </h1>
                                                </Col>

                                            </Row>

                                            <div className="optionSection">
                                                <Row className="">

                                                    <Col xl={5} lg={5} md={5} sm={23} xs={23}>

                                                        {renderUploadButton(keyForImage, key, field)}

                                                    </Col>
                                                    <Col xl={6} lg={6} md={6} sm={12} xs={12} className="gx-text-left">
                                                        <Form.Item
                                                            name={[field.name, 'optionLabel']}
                                                            fieldKey={[field.fieldKey, 'optionLabel']}
                                                            rules={[{ required: true, message: 'Missing Option Label' }]}
                                                        >
                                                            <Input placeholder="optionLabel" style={{ width: '100%' }} />

                                                        </Form.Item>
                                                        <Form.Item
                                                            name={[field.name, 'furtherDetail']}
                                                            label="Need Further Detail">
                                                            <Switch
                                                                onChange={(value) => showSwitchValue(value, field.name, key)}
                                                                defaultChecked={
                                                                    !showFurtherDetail.hasOwnProperty(newKey) ?
                                                                        QuestionObjectArray.questions[key[0]] && QuestionObjectArray.questions[key[0]]['questionOptionImage'][field.name] && QuestionObjectArray.questions[key[0]]['questionOptionImage'][field.name]['furtherDetail'] : showFurtherDetail[newKey]
                                                                }
                                                            />
                                                        </Form.Item>
                                                    </Col>


                                                    <Col xl={6} lg={6} md={6} sm={12} xs={12} className="gx-text-right">

                                                    </Col>
                                                </Row>
                                                <Row className="gx-mr-3">
                                                    <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                                                        <Form.Item
                                                            className="quilEditor"
                                                            name={[field.name, 'decisionTree']}
                                                            fieldKey={[field.fieldKey, 'decisionTree']}
                                                            rules={[{ required: true, message: 'Missing decision Tree' }]}
                                                            initialValue={QuestionObjectArray.questions ? QuestionObjectArray['questions'][key] ? QuestionObjectArray['questions'][key][field.name]['decisionTree'] : '' : ''}
                                                        >
                                                            {renderGermanEditor([field.name, 'decisionTree'])}
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                )
                            })
                            }
                            <Form.Item>
                                {fields.length < 5 && <Button type="dashed" className="gx-pt-0" style={{ maxWidth: '700px' }} onClick={() => add()} block icon={<PlusOutlined />}>
                                    Add options
                            </Button>}
                            </Form.Item>
                        </>
                    )
                }}
            </Form.List>

    }

    const increaseQuestionCount = () => {
        let newCount = questionCount + 1;
        setQuestionCount(newCount);
    }
    const reduceQuestionCount = () => {
        let newCount = questionCount - 1;
        setQuestionCount(newCount);
    }

    const renderQuestionCountNumber = () => {

        var foo = [];
        for (var i = 1; i <= questionCount; i++) {
            foo.push(i);
        }
        return foo.map(Item => {
            return <span to={`#${Item}_question`} onClick={() => executeScroll(Item - 1)} className={`gx-link gx-d-block gx-pb-1 ${selectedQuestionIndex === Item - 1 ? "selectedQuestion" : ""}`}><h5>{Item}</h5></span>
        })

    }

    const renderSelectOptionType = (field) => {
        if (
            ((QuestionObjectArray && QuestionObjectArray.questions && QuestionObjectArray.questions[field.name]) && ((QuestionObjectArray.questions && QuestionObjectArray.questions[field.name]['questionType'] === "Radio") || (QuestionObjectArray.questions && QuestionObjectArray.questions[field.name]['questionType'] === "CheckBox")))
            ||
            (typeOfQuestion[`${[field.name, 'questionType'].join("-")}`] && (typeOfQuestion[`${[field.name, 'questionType'].join("-")}`] === "Radio" || typeOfQuestion[`${[field.name, 'questionType'].join("-")}`] === "CheckBox"))

        ) {
            return <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                <Row>
                    <Col xl={4} lg={4} md={4} sm={24} xs={24} className="gx-text-left">
                        <span>Select Option Type</span>
                    </Col>
                    <Col xl={18} lg={18} md={18} sm={22} xs={22} className="gx-text-left">
                        <Form.Item
                            name={[field.name, 'questionOptionType']}
                            fieldKey={[field.fieldKey, 'questionOptionType']}
                            rules={[{ required: true, message: 'Missing Question Option Type' }]}
                        >
                            <Select style={{ width: 500 }} onChange={(value) => questionOptionTypeSelected(value, [field.name, 'questionOptionType'])}>
                                {SelectQuestionOptionType.map(item => (
                                    <Option key={item} value={item}>
                                        {item}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        }

    }


    const setSubQuestionQuestionFn = (data) => {
        let subQuestion = supQuestions;
        subQuestion[selectedQuestion] = data
        setSubQuestionQuestion({ ...subQuestion });
        dispatch({
            type: ModalType,
            payload: null

        })
    }

    return (
        <Layout>
            {fetchingLoader ?
                <Spin size="large" color="blue" />
                : <Form
                    name="dynamic_form_nest_item"
                    onFinish={onFinish}
                    autoComplete="off"
                    initialValues={QuestionObjectArray}
                >

                    <Row>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <h1 className="gx-d-flex gx-flex-row gx-justify-content-between gx-font-18">
                                Daily Living Activities
                        <Form.Item className="gx-mb-2">
                                    {dailyActivityLoader ?
                                        <Spin size="small" color="white"><Button type="primary" disabled htmlType="submit" className="gx-pt-0 gx-mb-0">
                                            Save
                                        </Button></Spin>
                                        : <Button type="primary" htmlType="submit" className="gx-pt-0 gx-mb-0">
                                            Save
                                        </Button>
                                    }
                                </Form.Item>
                            </h1>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                name="dailyLivingActivityText"
                                rules={[{ required: true, message: 'Daily Living Activity Text' }]}
                                initialValue={QuestionObjectArray.dailyLivingActivityText ? QuestionObjectArray.dailyLivingActivityText : ''}
                            >
                                {renderGermanEditor('dailyLivingActivityText')}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>

                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <div>
                                <Form.List name="questions">
                                    {(fields, { add, remove }) => (
                                        <>
                                            <Row className="gx-mt-3 gx-mr-1">
                                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <div className="gx-d-flex gx-flex-row gx-justify-content-between questionHeader gx-align-items-center gx-mb-3">
                                                        <h1 className="gx-font-18">Daily Living Activities Question</h1>
                                                        <Form.Item className="gx-mb-0">
                                                            <Button type="dashed" className="gx-pt-0 gx-mb-0" onClick={() => { add(); increaseQuestionCount() }} icon={<PlusOutlined />}>
                                                                Add Question
                                                        </Button>
                                                        </Form.Item>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                                                    <div className="showQuestionCount">
                                                        <div>
                                                            <span>Sr.no</span>
                                                        </div>
                                                        {renderQuestionCountNumber()}
                                                    </div>
                                                </Col>

                                                <Col xl={22} lg={22} md={22} sm={22} xs={22} style={{ height: '600px', overflowY: 'scroll' }}>
                                                    {fields.map((field, index) => (
                                                        <section className="questionContainer" ref={setRef(`questionId_${index}`)} key={field.key} id={`${index + 1}_question`}>
                                                            <Row className="gx-m-0 gx-p-0">
                                                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-p-0">
                                                                    <h1 className="questionContainerHeader">
                                                                        <span>Question No: {index + 1}</span>
                                                                        <Form.Item name={[field.name, 'allowFreeUserToSee']}
                                                                            fieldKey={[field.fieldKey, 'allowFreeUserToSee']}
                                                                            label="Allow Free User To See" valuePropName="checked">
                                                                            <Switch />
                                                                        </Form.Item>
                                                                        <Button type="dashed" className="gx-pt-0" onClick={() => { remove(field.name); reduceQuestionCount() }}>
                                                                            <span style={{ color: 'red' }}>Delete</span>
                                                                        </Button>
                                                                    </h1>
                                                                </Col>
                                                            </Row>
                                                            <Row style={{
                                                                padding: '30px 27px'
                                                            }}>
                                                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Row className="gx-mr-3">
                                                                        <Col xl={4} lg={4} md={4} sm={24} xs={24} className="gx-text-left">
                                                                            <span>Question label</span>
                                                                        </Col>
                                                                        <Col xl={18} lg={18} md={18} sm={22} xs={22} className="gx-text-left">
                                                                            <Form.Item
                                                                                name={[field.name, 'questionLabel']}
                                                                                fieldKey={[field.fieldKey, 'questionLabel']}
                                                                                rules={[{ required: true, message: 'Missing Question Label' }]}
                                                                            >
                                                                                <Input placeholder="Question Label" style={{ width: 500 }} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <Row>
                                                                        <Col xl={4} lg={4} md={4} sm={24} xs={24} className="gx-text-left">
                                                                            <span>Select type</span>
                                                                        </Col>
                                                                        <Col xl={18} lg={18} md={18} sm={22} xs={22} className="gx-text-left">
                                                                            <Form.Item
                                                                                label=""
                                                                                name={[field.name, 'questionType']}
                                                                                fieldKey={[field.fieldKey, 'questionType']}
                                                                                rules={[{ required: true, message: 'Missing Question Type' }]}
                                                                            >
                                                                                <Select style={{ width: 500 }} onChange={(value) => questionTypeSelected(value, [field.name, 'questionType'])}>
                                                                                    {SelectQuestionType.map(item => (
                                                                                        <Option key={item} value={item}>
                                                                                            {item}
                                                                                        </Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </Col>

                                                                    </Row>
                                                                </Col>
                                                                {renderSelectOptionType(field)}
                                                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-p-0">
                                                                    {renderFormListWithImageOption([field.name, 'questionOptionImage'], [field.name, 'questionOptionType'])}
                                                                </Col>
                                                                <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-p-0">
                                                                    {renderFormListWithOutImage([field.name, 'questionOption'], [field.name, 'questionOptionType'])}
                                                                </Col>

                                                            </Row>
                                                        </section>
                                                    ))}
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </Form.List>
                            </div>
                        </Col>
                    </Row>

                </Form>
            }

            <SubQuestion modalType={ModalType} setSubQuestion={(data) => setSubQuestionQuestionFn(data)} />
        </Layout>
    )
}

export default Index
